// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"60":"alcohol","405":"accessiblity","556":"cannabis","796":"vaping"}[chunkId] || chunkId) + "." + {"60":"45256b7c","405":"e74d6a6f","556":"497efd64","636":"5f4af1d6","796":"7793c22c"}[chunkId] + ".js";
};